// import request from "@/utils/request";
// import upload from '@/utils/upload'
import request from "@/utils/cdRequest";

/*
 * 川大通用列表查询接口
 */
export function getNewsList(data) {
  return request({
    url: "/interface/getNewsList.do",
    method: "post",
    data,
  });
}

/*
 * 川大通用详情查询接口
 */
export function getNewsContent(data) {
  return request({
    url: "/interface/getNewsContent.do",
    method: "post",
    data,
  });
}